export default __webpack_public_path__ + "static/media/ksa.476d4f27.svg";